import { useEffect, useState } from 'react';
import { Input } from './input.component';
import { SearchIcon } from '@umanforge/common';

const WAIT_TIME: number = 650;

interface ButtonProp {
  value: string;
  onSearched: ( value: string ) => void;
  t: ( key: string ) => string;
};


export function SearchInput( { value, onSearched, t }: ButtonProp ) {

  const [ searchedValue, setSearchedValue ] = useState<string>( value );
  const [ renderNumber, setRenderNumber ] = useState<number>( 0 );

  useEffect( () => {
    setRenderNumber( renderNumber + 1 );
  }, [] );


  useEffect( () => {
    if ( renderNumber > 0 ) {
      const timeOutId = setTimeout( () => { searched( searchedValue ); }, WAIT_TIME );
      return () => { clearTimeout( timeOutId ); };
    }
  }, [ searchedValue ] );

  const searched = ( str: string ) => {
    onSearched( str );
  };


  return (
    <Input
      value={ searchedValue }
      icon={ <SearchIcon className='w-8 h-8'/> }
      placeholder={ t( 'Search' ) + '...'}
      onKeyEnterUp={ e => { searched( ( e.target as HTMLInputElement ).value ); } }
      onChange={ searchedText => { setSearchedValue( searchedText ); } }
    />
  );
};